import 'react-native-url-polyfill/auto'; // Support URL, URLSearchParams, etc. pour Hermes
import { registerRootComponent } from 'expo';
import { activateKeepAwakeAsync } from 'expo-keep-awake';
import './src/polyfills/intl';
import { createRoot } from 'react-dom/client';
import { createElement } from 'react';
import { Platform } from 'react-native';
import App from './src/App';

// Reanimated (web) workaround
if (typeof window !== 'undefined') {
  window._frameTimestamp = null;
}

if (__DEV__) {
  // Garde l'écran éveillé en dev (ignore la promesse si non supporté)
  activateKeepAwakeAsync().catch(() => {});

  // Network inspect en dev
  global.XMLHttpRequest = global.originalXMLHttpRequest || global.XMLHttpRequest;
}

if (Platform.OS === 'web') {
  const container = document.getElementById('root') ?? document.getElementById('main');
  const root = createRoot(container);
  root.render(createElement(App));
} else {
  registerRootComponent(App);
}
